import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "result-page" }
const _hoisted_2 = {
  key: 2,
  class: "container mx-auto px-4 py-8"
}
const _hoisted_3 = { class: "flex justify-center gap-4 mt-8" }

import { onMounted } from "vue";
import { useRouter } from "vue-router";
import GeneratedPost from "../components/GeneratedPost.vue";
import LoadingComponent from "../components/LoadingComponent.vue";
import Button from "primevue/button";
import Message from "primevue/message";
import Toast from "primevue/toast";
import { usePostGeneration } from "../composables/usePostGeneration";


export default /*#__PURE__*/_defineComponent({
  __name: 'ResultPage',
  setup(__props) {

const router = useRouter();
const {
  isLoading,
  loadingStage,
  error,
  generatedPost,
  copyPost,
  generatePost,
  regeneratePost,
  progressPercentage,
} = usePostGeneration();

onMounted(async () => {
  await generatePost();
});

const goToHome = () => {
  router.push("/");
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(Toast)),
    (_unref(isLoading))
      ? (_openBlock(), _createBlock(LoadingComponent, {
          key: 0,
          stage: _unref(loadingStage),
          progress: _unref(progressPercentage)
        }, null, 8, ["stage", "progress"]))
      : (_unref(error))
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createVNode(_unref(Message), {
              severity: "error",
              closable: false,
              class: "mb-4"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(error)), 1)
              ]),
              _: 1
            }),
            _createVNode(_unref(Button), {
              label: "처음으로 돌아가기",
              onClick: goToHome,
              class: "mt-4"
            })
          ], 64))
        : (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(GeneratedPost, { content: _unref(generatedPost) }, null, 8, ["content"]),
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_unref(Button), {
                label: "다시 생성하기",
                onClick: _unref(regeneratePost),
                class: "p-button-info"
              }, null, 8, ["onClick"]),
              _createVNode(_unref(Button), {
                label: "포스트 복사하기",
                onClick: _unref(copyPost),
                class: "p-button-primary"
              }, null, 8, ["onClick"])
            ])
          ])),
    _createVNode(_unref(Toast), {
      position: "bottom-center",
      group: "bc"
    })
  ]))
}
}

})